import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Plus, Trash2, Pencil, Check } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPES = [['note', 'Note 1-5'], ['texte', 'Texte libre'], ['ouinon', 'Oui / Non']];

export const QuestionsSatisfactionAdmin = () => {
  const [qs, setQs] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => axios.get(`${API_URL}/listes/questions-satisfaction`).then(r => setQs(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    if (!edit.libelle.trim()) return toast.error('Libellé obligatoire');
    try {
      if (edit.id) await axios.put(`${API_URL}/listes/questions-satisfaction/${edit.id}`, edit); else await axios.post(`${API_URL}/listes/questions-satisfaction`, edit);
      toast.success('Question enregistrée'); setEdit(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
  };
  const remove = async (q) => { if (window.confirm(`Supprimer « ${q.libelle} » ?`)) { await axios.delete(`${API_URL}/listes/questions-satisfaction/${q.id}`); load(); } };
  const sel = 'h-9 text-sm rounded-md border border-slate-200 bg-white px-2';
  return (
    <Card className="border-0 shadow-sm" data-testid="questions-satisfaction-admin">
      <CardContent className="p-4 space-y-5">
        <p className="text-xs text-slate-500">Questions des questionnaires de satisfaction de fin de formation (portail candidat / portail entreprise / saisie admin dans le Bilan).</p>
        {[['candidat', 'Questionnaire candidat'], ['entreprise', 'Questionnaire entreprise']].map(([cible, label]) => (
          <div key={cible} data-testid={`questions-${cible}`}>
            <div className="flex items-center justify-between mb-2"><p className="text-sm font-semibold text-slate-800">{label}</p>
              <Button size="sm" variant="outline" onClick={() => setEdit({ cible, libelle: '', type: 'note', actif: true })} data-testid={`btn-add-question-${cible}`}><Plus className="w-3.5 h-3.5 mr-1" /> Ajouter</Button></div>
            <div className="border rounded-lg divide-y">
              {qs.filter(q => q.cible === cible).map(q => (
                <div key={q.id} className={`flex items-center gap-3 px-3 py-2 text-sm ${q.actif === false ? 'opacity-50' : ''}`} data-testid={`question-row-${q.id}`}>
                  {edit?.id === q.id ? (<>
                    <Input className="h-9 flex-1" value={edit.libelle} onChange={(e) => setEdit({ ...edit, libelle: e.target.value })} data-testid="question-libelle-input" />
                    <select className={sel} value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })}>{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
                    <label className="text-xs flex items-center gap-1"><input type="checkbox" checked={edit.actif !== false} onChange={(e) => setEdit({ ...edit, actif: e.target.checked })} /> Active</label>
                    <Button size="icon" variant="ghost" className="h-8 w-8" onClick={save} data-testid="question-save-btn"><Check className="w-4 h-4 text-emerald-600" /></Button>
                  </>) : (<>
                    <span className="flex-1 text-slate-700">{q.libelle}</span>
                    <span className="text-[11px] text-slate-400 shrink-0">{TYPES.find(t => t[0] === q.type)?.[1]}</span>
                    <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setEdit({ ...q })} data-testid={`question-edit-${q.id}`}><Pencil className="w-3.5 h-3.5" /></Button>
                    <Button size="icon" variant="ghost" className="h-8 w-8 text-red-500" onClick={() => remove(q)} data-testid={`question-delete-${q.id}`}><Trash2 className="w-3.5 h-3.5" /></Button>
                  </>)}
                </div>
              ))}
              {edit && !edit.id && edit.cible === cible && (
                <div className="flex items-center gap-3 px-3 py-2 text-sm bg-indigo-50/40" data-testid="question-new-row">
                  <Input className="h-9 flex-1" placeholder="Libellé de la question" value={edit.libelle} onChange={(e) => setEdit({ ...edit, libelle: e.target.value })} data-testid="question-libelle-input" />
                  <select className={sel} value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })} data-testid="question-type-select">{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
                  <Button size="sm" onClick={save} className="bg-indigo-600 hover:bg-indigo-700" data-testid="question-save-btn">Enregistrer</Button>
                  <Button size="sm" variant="ghost" onClick={() => setEdit(null)}>Annuler</Button>
                </div>
              )}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
